import { Component } from '@angular/core';
import { ControlContainer, FormArray, FormGroup } from '@angular/forms';
import { RasterLayerConfigurationForm, RasterLayerFormComponent } from '../raster-layer-form/raster-layer-form.component';
import { GroupedMetadata } from '@models/mood/metadata';
import { GroupedFileFormConfiguration } from '../grouped-file-form/grouped-file-form.component';


export interface GroupedDatasetConfigurationForm extends RasterLayerConfigurationForm {
  files: FormArray<FormGroup<GroupedFileFormConfiguration>>;
}

@Component({
  selector: 'mood-grouped-dataset-configuration',
  templateUrl: './grouped-dataset-metadata-form.component.html',
  styleUrls: [
    'grouped-dataset-metadata-form.component.scss'
  ]
})
export class GroupedDatasetConfigurationFormComponent {
  constructor(private _controlContainer: ControlContainer) { }

  get formGroupContainer() {
    return this._controlContainer.control as FormGroup<GroupedDatasetConfigurationForm>;
  }

  get filesArray() {
    return this.formGroupContainer.get('files') as FormArray;
  }

  public static createMetadataFormGroup(existingConfig?: GroupedMetadata) {
    let formGroup = (RasterLayerFormComponent.createMetadataFormGroup(existingConfig) as unknown) as  FormGroup<GroupedDatasetConfigurationForm>;

    formGroup.addControl('files', new FormArray<FormGroup<GroupedFileFormConfiguration>>([]));

    return formGroup;
  }
}
